import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { URLLinkValidate, YTLinkValidate, FBLinkValidate, INSTLinkValidate, VKLinkValidate, SlugValidate, VKVideoLinkValidate, VKPlaylistLinkValidate, HashtagValidate } from '@app/utils/validator';


@Injectable()

export class InputValidators {
  constructor() {
  }

  checkIdValue(control: AbstractControl): any {
    if (control.value === 0) {
      return { valid: false };
    }
  }

  checkURLValue(control: AbstractControl): any {
    if (control.value !== '' && !URLLinkValidate(control.value)) {
      return { valid: false }
    }
  }

  checkYTValue(control: AbstractControl): any {
    if (control.value !== '' && !YTLinkValidate(control.value)) {
      return { valid: false }
    }
  }

  checkVKValue(control: AbstractControl): any {
    if (control.value !== '' && !VKLinkValidate(control.value)) {
      return { valid: false }
    }
  }

  checkFBValue(control: AbstractControl): any {
    if (control.value !== '' && !FBLinkValidate(control.value)) {
      return { valid: false }
    }
  }

  checkINSTValue(control: AbstractControl): any {
    if (control.value !== '' && !INSTLinkValidate(control.value)) {
      return { valid: false }
    }
  }

  checkSlugValue(control: AbstractControl): any {
    const v = control.value;
    if (v === '' || v == null) return null;
    if (!SlugValidate(String(v).toLowerCase())) {
      return { valid: false };
    }
  }

  checkVKVideoValue(control: AbstractControl): any {
    if (control.value !== '' && !VKVideoLinkValidate(control.value)) {
      return { valid: false };
    }
  }

  checkVKPlaylistValue(control: AbstractControl): any {
    if (control.value !== '' && !VKPlaylistLinkValidate(control.value)) {
      return { valid: false };
    }
  }

  checkHashtagsValue(control: AbstractControl): any {
    const v = control.value;
    if (!v || !Array.isArray(v)) return null;
    if (v.length > 10) return { valid: false };
    const invalid = v.some(tag => !HashtagValidate(tag));
    if (invalid) return { valid: false };
  }
}
